// ai/* page translations
const ai = {
  aiAnalysis: {
    newChat: 'New chat',
    send: 'Send',
    file: {
      excel: 'Excel file',
      csv: 'CSV file',
      pdf: 'PDF file',
      file: 'File',
      rows: '({n} rows)',
      download: 'Download',
      ready: 'Data ready',
    },
    title: 'AI Analysis',
    welcome: 'Hello! I am your AI analysis assistant. Please ask me about injection molding equipment data, production status, alarm analysis, and more.',
    welcomeMatch: 'Hello! I am your AI analysis assistant',
    noResponse: 'No response received.',
    errorMessage: 'Sorry, an error occurred while processing your message. Please try again later.',
    assistant: 'AI Assistant',
    user: 'User',
    suggestionsTitle: 'Suggested Questions',
    placeholder: 'Type your question... (Shift+Enter for newline)',
    suggestions: {
      qualityDefectTrend: 'Show recent defect rate trend as a line chart',
      qualityTopAlarmEquip: 'Which equipment had the most quality alarms today?',
      qualityTempAnalysis: 'Analyze recent temperature changes for Injection Machine #1',
      qualityDefectByEquip: 'Show defect occurrence per equipment over the last 7 days as a bar chart',
      productionRunningEquip: 'What is the current status of running equipment?',
      productionTopOutput: 'Which equipment has the highest production today?',
      productionTrend: 'Show the production trend for the last 7 days as a line chart',
      productionUtilizationCompare: 'Compare utilization rates across equipment',
      maintenanceTopAlarm: 'Which equipment had the most alarms today?',
      maintenanceAlarmTrend: 'Show alarm occurrence trend per equipment over the last 7 days',
      maintenanceCycleTimeAnalysis: 'Analyze recent cycle time changes for Injection Machine #1',
      maintenanceIdleEquip: 'What is the current status of idle equipment?',
      defaultRunningEquip: 'What is the current status of running equipment?',
      defaultTopAlarm: 'Which equipment had the most alarms today?',
      defaultTrend: 'Show the production trend for the last 7 days as a line chart',
      defaultShotTempAnalysis: 'Analyze recent shot temperature changes for Injection Machine #1',
    },
  },
  aiManage: {
    addBtn: 'Add model connection',
    tabs: { connections: 'Model connections', calls: 'Call history' },
    provider: { OPENAI_COMPATIBLE: 'OpenAI-compatible (DGX, LM Studio, ...)', ANTHROPIC: 'Anthropic Claude' },
    feature: {
      CHAT_SQL: 'AI Analysis · question parsing & SQL generation (tool use)',
      CHAT_ANSWER: 'AI Analysis · answer writing',
      ANALYSIS: 'AI Analysis · data analysis agent',
      VISUALIZATION: 'AI Analysis · chart generation',
      REPORT: 'Reports · daily/weekly/monthly reports, alarm analysis, suggestions',
    },
    featureShort: { CHAT_SQL: 'SQL', CHAT_ANSWER: 'Answer', ANALYSIS: 'Analysis', VISUALIZATION: 'Chart', REPORT: 'Report' },
    connections: {
      title: 'Model connections',
      help: 'LLM connections used by the chatbot and reports. Keys are stored encrypted and never shown again. Leave the key empty to use the server environment variable (OPENAI_API_KEY / ANTHROPIC_API_KEY).',
      empty: 'No model connections registered.',
    },
    card: {
      active: 'Active', inactive: 'Inactive', keySaved: 'Key saved', keyEnv: 'Env key', keyNone: 'No key',
      workspace: 'Workspace', testFailed: 'Connection failed — see the error details below', errorDetail: 'Show error details',
      noFeatures: 'No features assigned', test: 'Test', testing: 'Testing…', edit: 'Edit', delete: 'Delete',
      deleteBlocked: 'Features are assigned to this connection. Reassign them first.',
    },
    assign: {
      title: 'Model per feature',
      help: 'Choose which connection each feature uses. Changes apply from the next call. Unassigned features use the first active connection.',
      feature: 'Feature', connection: 'Connection', updated: 'Updated', none: '(unassigned · first connection)',
    },
    form: {
      addTitle: 'Add model connection', editTitle: 'Edit model connection',
      connKey: 'Connection key', name: 'Name', provider: 'Provider', apiBase: 'API base URL', modelName: 'Model',
      loadModels: 'Load model list', modelsLoaded: 'Loaded {n} models. Pick one in the input.', noModels: 'The model list is empty.',
      apiKey: 'API key', apiKeyKeep: 'Leave empty to keep the stored key', apiKeyEnv: 'Leave empty to use the server env key', clearKey: 'Remove stored key',
      workspaceId: 'Workspace ID (optional)', workspaceHint: 'Only for keys not scoped to a workspace (sk-ant-usr…). Use the workspace ID from Claude Console (wrkspc_…).',
      timeoutMs: 'Timeout (ms)', maxTokens: 'Max tokens', temperature: 'temperature', effort: 'effort (thinking depth)',
      sortOrder: 'Order', isActive: 'Active', description: 'Description', default: 'default',
      anthropicHint: 'Claude 5.x ignores temperature and controls thinking depth with effort. "low" is fastest for chat.',
      required: 'Connection key, name and model are required.',
    },
    calls: {
      title: 'Last 100 calls', todayCalls: 'Calls today', todayTokens: 'Tokens today', monthCalls: 'Calls this month', monthTokens: 'Tokens this month',
      monthFailures: 'Failures this month', avgLatency: 'Avg latency', byConnection: 'This month by connection',
      time: 'Time', feature: 'Feature', connection: 'Connection', model: 'Model', tenant: 'Site', inTokens: 'Input tokens', outTokens: 'Output tokens',
      latency: 'Latency (ms)', result: 'Result', failed: 'Failed', empty: 'No calls yet.',
    },
    msg: { saved: 'Saved.', deleted: 'Deleted.', assigned: 'Assignment updated.', confirmDelete: "Delete connection '{name}'?" },
  },
};

export default ai;
